<template>
  <div class="quote js-botTopFadeIn" :id="'quote-' + this.patient + '--' + this.blockID">
    <div class="quote_text-wrapper" :class="{'jsc-center': !this.hasFooter}">
      <p class="quote_text" v-for="text in this.patients[this.patient].infoBlocks[this.blockID]" :key='text.id' v-html="text.text"></p>
    </div>
    <div class="quote_footer-wrapper" v-if="this.hasFooter">
      <p class="quote_name" v-html="this.patients[this.patient].name"></p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Quote',
  data() {
    return {};
  },
  props: {
    patient: {
      type: String
    },
    blockID: {
      type: Number
    },
    hasFooter: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState(['userAgent', 'patients'])
  }
};
</script>

<style lang="scss">
.quote {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 650px;
  min-height: 282px;
  margin: 0 auto;
  //
  background-size: 282px 186px;
  background-image: url("~@/assets/img/quote/quote-bg.png");
  background-repeat: no-repeat;
  background-position: center center;
}

.quote_text-wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;

  .quote_text {
    font-family: 'Roboto', sans-serif;
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: italic;
    line-height: 1.27;
    letter-spacing: normal;
    color: #000000;
  }
}

.quote_footer-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 48px;
  position: relative;
  padding-top: 15px;

  .quote_name {
    font-family: 'Roboto', sans-serif;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    text-align: right;
    color: #000000;
    padding-left: 5px;
  }
}

// CORRECTIONS
.jsc-center {
  text-align: center;
  justify-content: center;
  align-items: center;
}
</style>
